export function validateCategory(category, isUpdate = false) {
    const errors = {};
  
    if (!category.name?.trim()) {
      errors.name = "Category name is required";
    }
  
    if (!category.unitMeasurement) {
      errors.unitMeasurement = "Unit measurement is required";
    }
  
    if (
      category.unitMeasurement === "Custom" &&
      !category.customUnitMeasurement?.trim()
    ) {
      errors.customUnitMeasurement = "Custom unit measurement is required";
    }
  
    // Image is required for creation, but optional for updates
    if (!isUpdate && !category.image) {
      errors.image = "Category image is required";
    }
  
    return errors;
  }
  
  export function validateCategories(categories) {
    const result = [];
  
    categories.forEach((cat, index) => {
      const errors = validateCategory(cat, false);
      if (Object.keys(errors).length > 0) {
        result.push({ index, errors });
      }
    });
  
    return result;
  }
  